import { useTranslation } from '@shared/core';
import { EventPageType, EventPageVisibility, EventWebsiteGuestQuery, GetRegistryDataQuery } from '@graphql/generated';
import { EventFeature, useProFeature } from '@shared/hooks/useProFeature';
import { useEventInfo } from '@shared/utils/eventInfo';

export const useAppPage = () => {
  const { tq } = useTranslation('eventSiteApps');
  const disableAddAppPage = useProFeature(EventFeature.disableAddAppPage);
  const { eventInfo } = useEventInfo();

  const addAppPage = (eventHandle: string | undefined, event: EventWebsiteGuestQuery['eventByName'] | GetRegistryDataQuery['eventByName']) => {
    const newPages = event?.pages ? [...event.pages] : [];

    const hideDownloadAppPage = eventInfo?.settings.hideDownloadAppPage ?? false;

    if (!disableAddAppPage && !hideDownloadAppPage) {
      newPages.push({
        id: 'app',
        disabled: false,
        mobilePhoto: null,
        pageSlug: 'app',
        pageTitle: tq`Get the app`,
        photoV2: null,
        subTitle: tq`Download Joy and join our app using our event handle ${eventHandle}. View and share photos and stay up-to-date with details on the go.`,
        type: EventPageType.app,
        isPageContainer: false,
        visibility: EventPageVisibility.public,
      });
    }

    return newPages;
  };

  return addAppPage;
};
